export const oauthRoutePath = '/oauth';
